window.STUDY_TRADES_FRANK_CONFIG = {
  intro:
    "Hey, I'm Frank. I can help you find the right license, check your next step, and answer quick questions.",
  launcherLabel: "Ask Frank",
  restartLabel: "Start over",
  closeLabel: "Close Frank",
  capturePrompt: "Want me to send these next steps to your inbox?",
  captureDisclaimer: "Name is optional. Email lets me save your progress and send the right next-step message.",
  pricingUrl: "/#license-selector",
  faqUrl: "/pages/faq",
  signupUrl: "/pages/signup?stateCode=CA&stateLabel=California",
  blogUrl: "/#blogs",
  applicationGuideUrl: "/#start-here",
  inProgressHelpUrl: "/#faq",
  showOnPaths: ["/", "/pages/get-started"],
  intents: [
    { id: "find_license", label: "Which license should I choose?" },
    { id: "readiness_check", label: "Am I eligible to apply?" },
    { id: "product_explainer", label: "What do I get with Study Trades?" },
    { id: "pricing_help", label: "How does pricing work?" },
    { id: "faq", label: "Can you answer a few common questions?" }
  ],
  faqCategories: [
    { id: "getting_started", label: "Getting started" },
    { id: "choosing_license", label: "Choosing a license" },
    { id: "pricing", label: "Pricing" },
    { id: "included", label: "What's included" },
    { id: "availability", label: "Availability" },
    { id: "readiness", label: "Readiness" },
    { id: "waitlist", label: "Waitlist" }
  ],
  readinessQuestions: [
    {
      id: "experienceStatus",
      question: "Do you already meet the basic experience requirement for this license?",
      choices: [
        { value: "qualified", label: "Yes" },
        { value: "building", label: "Not yet" },
        { value: "unsure", label: "Not sure" }
      ]
    },
    {
      id: "goalStatus",
      question: "Are you mainly trying to prep for the exam now, or are you still figuring out eligibility?",
      choices: [
        { value: "prep_now", label: "Prep now" },
        { value: "figuring_it_out", label: "Still figuring it out" }
      ]
    },
    {
      id: "timelineStatus",
      question: "Are you hoping to apply soon?",
      choices: [
        { value: "soon", label: "Yes" },
        { value: "later", label: "Not yet" },
        { value: "not_sure", label: "Not sure" }
      ]
    }
  ],
  faq: [
    {
      id: "what-is-study-trades",
      category: "getting_started",
      question: "What is Study Trades?",
      keywords: ["what is study trades", "what do you do", "study trades"],
      answer:
        "Study Trades helps future contractors move through exam prep and licensing decisions with clearer guidance, practical study materials, and next-step support. The exact product experience depends on the license you choose.",
      primaryCtaLabel: "Find my license",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    },
    {
      id: "how-do-i-start",
      category: "getting_started",
      question: "How do I get started?",
      keywords: ["how do i start", "get started", "start"],
      answer:
        "Start by choosing your state and license. If the license is live, Frank can point you toward the right study guide. If it is not live yet, Frank can save your waitlist request so you hear about the launch.",
      primaryCtaLabel: "Find my license",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    },
    {
      id: "which-license-do-i-need",
      category: "choosing_license",
      question: "How do I know which license I need?",
      keywords: ["which license", "choose license", "what license do i need"],
      answer:
        "The right license depends on the kind of work you want to bid, supervise, and advertise. Frank can narrow that down by state and license type, but if your situation is still fuzzy, start with the FAQ and launch guide before you buy anything.",
      primaryCtaLabel: "Am I ready to apply?",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California",
      secondaryCtaLabel: "Read the FAQ",
      secondaryCtaHref: "/pages/faq"
    },
    {
      id: "can-i-study-before-applying",
      category: "choosing_license",
      question: "Can I study before I apply?",
      keywords: ["study before applying", "before i apply", "can i start now"],
      answer:
        "Yes, many people start studying before they submit the application. The better question is whether paying now makes sense for your timeline. Frank's readiness check is meant to help you sort that out before you commit.",
      primaryCtaLabel: "Run the readiness check",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    },
    {
      id: "what-does-included-mean",
      category: "included",
      question: "What do I get with Study Trades?",
      keywords: ["what do i get", "included", "comes with", "study materials"],
      answer:
        "Study Trades products are built around contractor exam prep and next-step guidance. Depending on the license, that can include study content, practice-based prep, and clearer direction on what to do next.",
      primaryCtaLabel: "See pricing",
      primaryCtaHref: "/#license-selector"
    },
    {
      id: "is-law-and-business-separate",
      category: "pricing",
      question: "Is Law and Business separate?",
      keywords: ["law and business", "separate", "addon"],
      answer:
        "For some California flows, Law and Business can be treated separately from the trade-specific license prep. Frank will keep you on the right track, but the safest move is to check the plan section for the exact product setup tied to your license.",
      primaryCtaLabel: "See pricing",
      primaryCtaHref: "/#license-selector"
    },
    {
      id: "how-pricing-works",
      category: "pricing",
      question: "How does pricing work?",
      keywords: ["price", "pricing", "cost", "how much"],
      answer:
        "At Study Trades, our motto is keep it simple. There is a flat fee for our guided online process to help you get licensed fast. First-time licensees in California usually need Law and Business in addition to their chosen license, for a combined total of $495. If you only need Law and Business, that is $250. If you are applying for multiple licenses, you would choose one primary license and then add sub-licenses for an additional fee per extra license.",
      primaryCtaLabel: "Find my license",
      primaryCtaHref: "/#license-selector"
    },
    {
      id: "is-my-license-available",
      category: "availability",
      question: "How do I know if my license is available?",
      keywords: ["available", "is my license live", "launch", "waitlist"],
      answer:
        "Availability depends on your state and target license. Frank can check that quickly and either send you to the right product or let you join the waitlist if it is not live yet.",
      primaryCtaLabel: "Check availability",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    },
    {
      id: "outside-california",
      category: "availability",
      question: "What if I am outside California?",
      keywords: ["outside california", "another state", "not california"],
      answer:
        "If your state is not live yet, Frank can put you on the waitlist and make sure you get a welcome message plus the right update later. That way you do not lose your place while Study Trades expands into that market.",
      primaryCtaLabel: "Join the waitlist",
      primaryCtaHref: "/pages/signup?stateCode=WA&stateLabel=Washington"
    },
    {
      id: "am-i-ready",
      category: "readiness",
      question: "How do I know if I am ready to buy prep now?",
      keywords: ["ready", "am i ready", "should i buy now"],
      answer:
        "Frank can run a quick readiness check based on your state, license, experience, and timeline. It is not a legal determination, but it can help you decide whether to move forward now, wait, or do a little more homework first.",
      primaryCtaLabel: "Run the readiness check",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    },
    {
      id: "what-if-needs-work",
      category: "readiness",
      question: "What if I am not ready yet?",
      keywords: ["not ready", "needs work", "not eligible"],
      answer:
        "If you are not ready yet, that is still useful progress. Frank can point you toward the application guide, FAQ, and practical next steps so you do not spend money too early.",
      primaryCtaLabel: "Review the basics",
      primaryCtaHref: "/#start-here",
      secondaryCtaLabel: "Read the FAQ",
      secondaryCtaHref: "/pages/faq"
    },
    {
      id: "waitlist-what-happens",
      category: "waitlist",
      question: "What happens when I join the waitlist?",
      keywords: ["waitlist", "what happens after waitlist", "launch updates"],
      answer:
        "When you join the waitlist, Study Trades saves your state and license interest so you can get the right launch update later. If you opt in, you can also receive a confirmation message and future launch-related emails.",
      primaryCtaLabel: "Join the waitlist",
      primaryCtaHref: "/pages/signup?stateCode=CA&stateLabel=California"
    }
  ]
};
